"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectedValueWrapper = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _selectV2Theme = require("../selectV2Theme");
const SelectedValueWrapper = (0, _styled.default)("div")`
    position: absolute;

    // very specifically match the position of the input.
    left: ${_ref => {
  let {
    isContentBeforeVisible,
    themeMode
  } = _ref;
  return isContentBeforeVisible ? _selectV2Theme.selectV2Theme.input.padding.placeholder(themeMode) : _selectV2Theme.selectV2Theme.input.padding.left(themeMode);
}};

    // Allow the text to clip properly.
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    // Give the formatted stuff the space it needs to breathe.
    display: flex;
    align-items: center;
    height: 100%;
`;
exports.SelectedValueWrapper = SelectedValueWrapper;
//# sourceMappingURL=SelectedValueWrapper.js.map